import React from 'react';
import classNames from 'classnames';
import metaLogoSrc from 'assets/meta-partner.png';
import css from './InviteLayout.module.css';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LeaderBadge } from '../components/Badges/LeaderBadge';

type Props = {
  className?: string;
  children?: any;
};

export const InviteLayout = ({ className, children }: Props) => {
  return (
    <div className={classNames(className, css.wrapper)}>
      <Logo className={css.logo} />
      <div className={css.badges}>
        <LeaderBadge className={css.leader} whiteStyle />
        <img src={metaLogoSrc} className={css.meta} />
      </div>

      <div className={css.card}>{children}</div>
    </div>
  );
};
